export default __webpack_public_path__ + "5128e455616e080f17fcd8125632488a.svg";